import React from 'react'
import Modal from '../../shared/modal'
import { Box, Typography } from '@mui/material'
import { t } from '../../../i18n'

const scope = 'replenishment'

interface RemoveReplenishmentItemModalProps {
  itemForDeletion: {
    id: number | null
    type: 'product' | 'plates' | 'oil' | null
  }
  removeProductReplenishment: () => void
  removePlateReplenishment: () => void
  removeOilReplenishment: () => void
  setShowDeleteConfirmModal: (show: boolean) => void
}

const RemoveReplenishmentItemModal = ({
  itemForDeletion, removeProductReplenishment, removePlateReplenishment, removeOilReplenishment, setShowDeleteConfirmModal
}: RemoveReplenishmentItemModalProps) => {

  const removeReplenishment = () => {
    if(itemForDeletion.type == 'product') {
      removeProductReplenishment()
    } else if (itemForDeletion.type == 'plates') {
      removePlateReplenishment()
    } else if (itemForDeletion.type == 'oil') {
      removeOilReplenishment()
    }
  }

  return (
    <div className="remove-modal">
      <Modal
        onClose={() => setShowDeleteConfirmModal(false)}
      >
        <Box>
          <div className="replenishment-order-modal delete">
          <Typography variant="h6" component="h2">
            {t('remove_item_modal_text', { scope })}
          </Typography>
          <br/>
          <div className="modal-btn">
            <button className="btn btn-secondary" onClick={() => setShowDeleteConfirmModal(false)}>{t('cancel')}</button>
            <button className="btn btn-primary" onClick={removeReplenishment}>{t('remove')}</button>
          </div>
          </div>
        </Box>
      </Modal>
    </div>
  )
}

export default RemoveReplenishmentItemModal
